import React from 'react';
import { useSelector } from 'react-redux';
import BaseLayout from 'bento-ordering/base/layouts/BaseLayout';
import MenuLayout from 'bento-ordering/menus/layouts/MenuLayout';
import { useIsMobile } from 'styles/hooks/mediaQueries';
import { CHILDREN_PROP_TYPES } from 'propTypes/childrenPropTypes';

const LAYOUT_PADDING = {
  pl: 0,
  pr: 0,
  pb: 3
};

function MenuItemPageLayout({ children }) {
  const isFetching = useSelector(state => state.menuItemsDetail.isFetching);
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <BaseLayout
        hideNav
        layoutPadding={LAYOUT_PADDING}
        mobileFooter={null}
        hideBrandFooterOnMobile
        hideHeroOnMobile
        isModal
        isFetching={isFetching}
      >
        {children}
      </BaseLayout>
    );
  }

  return <MenuLayout>{children}</MenuLayout>;
}

MenuItemPageLayout.propTypes = {
  children: CHILDREN_PROP_TYPES
};

export default MenuItemPageLayout;
